import { connect, MapStateToProps } from 'react-redux';
import styled from 'styled-components';
import { getAccessToken } from 'api/Utils';
import { RootState } from 'store/store';
import CKEditorField, {
  CkEditorBaseConfig,
} from '../../../CKEditorField/CKEditorField';
import { IProviderItemViewWithData } from 'store/providers/providerTypes';
// import ClassicEditor from '@rastech-inc/ckeditor';
import { languageDirection } from '../../../../i18n';
import { border1 } from 'utils/style/colors';

type OwnProps = {
  item?: IProviderItemViewWithData;
  editing: boolean;
  content?: string;
  saving: boolean;
  updateContent: (content: string) => any;
};
type StateToProps = {
  token?: string;
};

type ComponentProps = StateToProps & OwnProps;

const Container = styled.div`
  max-width: 1024px;
  margin: 1rem auto 0rem auto;
`;

const CKView = styled.div`
  margin-top: 10px;
  table,
  th,
  td {
    border: ${border1};
    border-collapse: collapse;
  }
`;

const PageCKEditor = ({
  editing,
  token,
  content,
  updateContent,
}: ComponentProps) => {
  if (!editing)
    return (
      <CKView
        className="ck-view ck-content"
        dangerouslySetInnerHTML={{ __html: content || '' }}
      />
    );
  return (
    <Container className="fullHeight">
      <CKEditorField
        id={'editor'}
        disabled={!editing}
        style={{
          '--ck-focus-ring': '0px',
          height: '100%',
          background: 'red',
          direction: `${languageDirection()}`,
        }}
        // editor={ClassicEditor}
        data={content}
        // updateContent={updateContent}
        onChange={(_: any, editor: any) => {
          const data = editor.getData();
          updateContent(data);
        }}
        dir={languageDirection()}
        config={CkEditorBaseConfig(token)}
      />
    </Container>
  );
};

const mapStateToProps: MapStateToProps<StateToProps, OwnProps, RootState> = (
  state
) => {
  const token = getAccessToken(state);
  return { token };
};

export default connect(mapStateToProps, null)(PageCKEditor);
